{
	"_comment": "This file is updated by the build process. Do not edit it manually.",
	"version": "1.78.2",
	"hash": "11ca1bae6e4b4f55e882620d20d55762eaa45d65"
}
